/**
 * Phonics Letter Hh — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/hh/）
 */

const MEDIA_BASE = '/media/phonics/hh';
const V = 'v1';

export const letterData = {
  letter: 'H',
  title: 'Phonics',
  subtitle: 'Letter H',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段（Song = Chant，同一时段）
  songVideo: {
    src: `${MEDIA_BASE}/Hh.mp4?${V}`,
    startTime: 10,
    endTime: 80,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  // 统一 storySections
  storySections: [

    // Step 3: Learn the words (1) — hide and seek
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_hide_and_seek.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 3,
      lines: [
        // 右侧单词
        { en: 'hide', cn: '藏', audioEn: `${MEDIA_BASE}/w_en_hide.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hide.mp3?${V}` },
        { en: 'and', cn: '和', audioEn: `${MEDIA_BASE}/w_en_and.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_and.mp3?${V}` },
        { en: 'seek', cn: '找', audioEn: `${MEDIA_BASE}/w_en_seek.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_seek.mp3?${V}` },
        // 视频下方句子
        { en: 'hide and seek', cn: '捉迷藏', audioEn: `${MEDIA_BASE}/s_en_hide_and_seek.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_hide_and_seek.mp3?${V}` },
      ],
    },

    // Step 4: Learn the words (2) — hiding / h under（双视频并排）
    {
      label: 'Learn the words (2)',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words2_hiding.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` },
        { src: `${MEDIA_BASE}/video_words3_h_under.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` },
      ],
      splitAt: 1,
      lines: [
        // 左视频台词
        { en: 'hiding', cn: '正藏在', audioEn: `${MEDIA_BASE}/w_en_hiding.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hiding.mp3?${V}` },
        // 右视频台词
        { en: 'under', cn: '在...下面', audioEn: `${MEDIA_BASE}/w_en_under.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_under.mp3?${V}` },
      ],
    },

    // Step 5: Learn the words (3) — hiccup / h found（双视频并排）
    {
      label: 'Learn the words (3)',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words4_hiccup.mp4?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` },
        { src: `${MEDIA_BASE}/video_words5_h_found.mp4?${V}`, poster: `${MEDIA_BASE}/image17.png?${V}` },
      ],
      splitAt: 1,
      lines: [
        // 左视频台词
        { en: 'hiccup', cn: '打嗝', audioEn: `${MEDIA_BASE}/w_en_hiccup.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hiccup.mp3?${V}` },
        // 右视频台词
        { en: 'found', cn: '找到', audioEn: `${MEDIA_BASE}/w_en_found.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_found.mp3?${V}` },
      ],
    },

    // Step 6: Learn the Story (1) — Hen
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_hen.mp4?${V}`, poster: `${MEDIA_BASE}/image18.png?${V}` }],
      lines: [
        { en: 'Hen is hiding under the hat.', cn: '母鸡正藏在帽子下面。', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Where is hen?', cn: '母鸡在哪里？', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'I found you, Hen.', cn: '我找到你了，母鸡。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Step 6: Learn the Story (2) — Hippo
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_hippo.mp4?${V}`, poster: `${MEDIA_BASE}/image19.png?${V}` }],
      lines: [
        { en: 'Hippo is hiding in the hut.', cn: '河马正藏在小木屋里。', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Where is hippo?', cn: '河马在哪里？', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'I found you, Hippo.', cn: '我找到你了，河马。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
